import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SearchButton from "../../../components/buttons/search/search-btn";
import CustomTable from "../../../components/table/table";
import TextField from "../../../components/inputs/textfield";
import Snackbar from "../../../components/snackbar/snackbar";
import { admin_company_details, user_company_status } from "../admin.api";
import jwtDecode from "jwt-decode";
import "./view.css";
import Loader from "../../../components/loader/loader";
import { Helmet } from "react-helmet";
import Swal from "sweetalert2";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";
import moment from "moment";
import { upload_company_logo } from "../../admin/admin.api";
export default function View(props) {
  const [data, setData] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [url, setUrl] = useState("");
  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const eventParams = useParams();
  const handleListData = () => {
    admin_company_details(eventParams.id).then((resp) => {
      setData(resp.data);
      setIsActive(false);
    });
  };

  const handleUploadLogo = async () => {
    if (!data?.id) return;
    const { value: confirmed } = await Swal.fire({
      title: "Upload Logo",
      html:
        '<input id="swal-logo" type="file" class="swal2-file" accept=".jpg,.jpeg,.png" />' +
        '<div class="text-muted" style="font-size:12px;margin-top:6px;">Allowed: JPG/JPEG/PNG</div>',
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Upload",
      confirmButtonColor: "#0A223D",
      preConfirm: () => {
        const fileInput = document.getElementById("swal-logo");
        const file = fileInput && fileInput.files && fileInput.files[0];
        if (!file) {
          Swal.showValidationMessage("Please choose a logo file");
          return false;
        }
        const validTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (!validTypes.includes(file.type)) {
          Swal.showValidationMessage(
            "Invalid file type. Please upload JPG or PNG",
          );
          return false;
        }
        return file;
      },
    });

    if (confirmed) {
      try {
        const fileInput = document.getElementById("swal-logo");
        const file = fileInput.files[0];
        const form = new FormData();
        form.append("logo", file);
        setIsActive(true);
        const resp = await upload_company_logo(data.user_id, form);
        await handleListData();
        Swal.fire({ icon: "success", title: "Logo uploaded" });
      } catch (e) {
        Swal.fire({
          icon: "error",
          title: "Upload failed",
          text: e?.message || "",
        });
      } finally {
        setIsActive(false);
      }
    }
  };
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const handleDownload = (data, type) => {
    if (type === "logo") {
      let path = `${result}${data.logo}`;
      window.open(path, "_blank");
    } else if (type === "brochure") {
      let path = `${result}${data.upload_proposal}`;
      window.open(path, "_blank");
    } else {
      return false;
    }
  };

  useEffect(() => {
    handleListData();
  }, []);
  const activeStatus = (id) => {
    let status = Number(id);
    if (id === 0) {
      return "Pending";
    } else if (id === 1) {
      return "Submitted for Acceptance";
    } else if (id === 2) {
      return "Approved";
    } else if (id === 3) {
      return "Super Admin Reverted";
    } else if (id === 4) {
      return "Rejected";
    } else if (id === 5) {
      return "Reverted";
    } else {
      return null;
    }
  };
  const saMessage = (status) => {
    Swal.fire({
      inputLabel: "Message",
      input: "textarea",
      showCancelButton: false,
      confirmButtonColor: "#0A223D",
      confirmButtonText: "Submit",
      inputAttributes: {
        "aria-label": "Type your message here",
      },
      inputValidator: (value) => {
        if (!value) {
          return "Please describe the reason";
        }
      },
      showCancelButton: true,
    }).then((message) => {
      if (message.isConfirmed === true) {
        let fdata = {};
        if (adminType === 1) {
          if (status === 1) {
            fdata = {
              status_id: status,
              company_id: data.id,
              admin_message: message.value,
            };
          } else {
            fdata = {
              status_id: status,
              company_id: data.id,
              user_message: message.value,
            };
          }
        } else {
          fdata = {
            status_id: status,
            company_id: data.id,
            super_admin_message: message.value,
          };
        }

        setIsActive(true);
        user_company_status(fdata)
          .then((res) => {
            setSnackMessage(res.message);
            setIsSnackError(false);
            setSnackOpen(true);
            setIsActive(false);
          })
          .catch((error) => {
            setSnackMessage(error.message);
            setIsSnackError(true);
            setSnackOpen(true);
            setIsActive(false);
          });
      }
    });
  };
  const handleAdminActions = (status) => {
    let fdata = { status_id: status, company_id: data.id };
    setIsActive(true);
    user_company_status(fdata)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push("/kerala-companies-list");
    }
  };
  const handleEdit = () => {};
  return (
    <div>
      <Loader open={isActive} />

      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="view-container">
        <span className="d-flex justify-content-between">
          <h6 className="mb-0 pt-2">
            <b>Company Details</b>
          </h6>
          {/*      
        <button type="button" className="btn btn-primary">
          Back to List
        </button> */}
        </span>
        <hr />
        {/* <button
          type="button"
          className="btn btn-secondary btn-sm  mb-3"
          onClick={(e) => {
            props.history.push("/event-list/");
          }}
        >
          Back
        </button> */}
        <div className="data">
          {/* Company Details */}
          <div className="row">
            <div className="col-12">
              <b>Company Details</b>
            </div>
          </div>
          <div className="row">
            <div className="col-3">Name</div>
            <div className="col-1">:</div>
            <div className="col-7">{data.company_name}</div>
          </div>

          {data?.unique_application_ref_no && (
            <div className="row">
              <div className="col-3">Application ID</div>
              <div className="col-1">:</div>
              <div className="col-7">{data.unique_application_ref_no}</div>
            </div>
          )}
          <div className="row">
            <div className="col-3">CIN/Registration No.</div>
            <div className="col-1">:</div>
            <div className="col-7">{data.cin_number}</div>
          </div>
          <div className="row">
            <div className="col-3">Registered Office</div>
            <div className="col-1">:</div>
            <div className="col-7">{data.address}</div>
          </div>

          {/* Contact & Website */}
          <div className="row mt-3">
            <div className="col-12">
              <b>Website, Primary & Alternate Contact</b>
            </div>
          </div>
          {data.site_link && data.site_link !== "null" && (
            <div className="row">
              <div className="col-3">Website</div>
              <div className="col-1">:</div>
              <div className="col-7">{data.site_link}</div>
            </div>
          )}
          <div className="row">
            <div className="col-3">Primary Contact Name</div>
            <div className="col-1">:</div>
            <div className="col-7">{data.person_name}</div>
          </div>
          <div className="row">
            <div className="col-3">Designation</div>
            <div className="col-1">:</div>
            <div className="col-7">{data.person_designation}</div>
          </div>
          <div className="row">
            <div className="col-3">Email</div>
            <div className="col-1">:</div>
            <div className="col-7">{data.email}</div>
          </div>
          <div className="row">
            <div className="col-3">Mobile</div>
            <div className="col-1">:</div>
            <div className="col-7">{data.phone_no}</div>
          </div>
          {data?.alternate_email && (
            <div className="row">
              <div className="col-3">Alternate Email</div>
              <div className="col-1">:</div>
              <div className="col-7">{data.alternate_email}</div>
            </div>
          )}
          {data?.alternate_phone && (
            <div className="row">
              <div className="col-3">Alternate Mobile</div>
              <div className="col-1">:</div>
              <div className="col-7">{data.alternate_phone}</div>
            </div>
          )}

          <div className="row">
            <div className="col-3">New company / Existing company ?</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {" "}
              {data.company_status === "new_company"
                ? "New Company"
                : data.company_status === "existing_company"
                  ? "Existing Company"
                  : ""}
            </div>
          </div>
          <div className="row">
            <div className="col-3">Area Type</div>
            <div className="col-1">:</div>
            <div className="col-7">{data.area_type}</div>
          </div>
          {(data?.application_submitted_at ||
            data?.approved_at ||
            data?.created_at) && (
            <>
              {data?.application_submitted_at && (
                <div className="row">
                  <div className="col-3">Submitted At</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    {data.application_submitted_at
                      ? moment(data.application_submitted_at).format(
                          "DD-MM-YYYY",
                        )
                      : ""}
                  </div>
                </div>
              )}
              {data?.approved_at && (
                <div className="row">
                  <div className="col-3">Approved At</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    {data.approved_at
                      ? moment(data.approved_at).format("DD-MM-YYYY")
                      : ""}
                  </div>
                </div>
              )}
              {data?.created_at && (
                <div className="row">
                  <div className="col-3">Created At</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    {moment(data.created_at).format("DD-MM-YYYY")}
                  </div>
                </div>
              )}
            </>
          )}

          {/* Branding & Profile */}
          <div className="row mt-3">
            <div className="col-12">
              <b>Branding & Profile</b>
            </div>
          </div>
          {data?.logo && (
            <div className="row">
              <div className="col-3">Logo</div>
              <div className="col-1">:</div>
              <div className="col-7">
                <button
                  type="button"
                  onClick={(e) => handleDownload(data, "logo")}
                  className="btn btn-reject btn-dark btn-sm"
                >
                  Download Logo
                </button>
              </div>
            </div>
          )}
          {/* {!data?.logo && (
            <div className="row">
              <div className="col-3">Logo (HD PNG/JPG)</div>
              <div className="col-1">:</div>
              <div className="col-7">
                <button
                  type="button"
                  onClick={handleUploadLogo}
                  className="btn btn-approve btn-success btn-sm"
                >
                  Upload Logo
                </button>
              </div>
            </div>
          )} */}
          {data?.upload_proposal && (
            <div className="row">
              <div className="col-3">Brochure/Leaflet</div>
              <div className="col-1">:</div>
              <div className="col-7">
                <a
                  style={{ cursor: "pointer" }}
                  onClick={(e) => handleDownload(data, "brochure")}
                >
                  <b>Download File</b>
                </a>
                <div className="text-muted small">(Max 5MB, .doc/.pdf)</div>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-3">Short Company Profile</div>
            <div className="col-1">:</div>
            <div className="col-7">{data.abstract_project_proposal}</div>
          </div>

          {/* Business Info */}
          <div className="row mt-3">
            <div className="col-12">
              <b>Business Info</b>
            </div>
          </div>
          <div className="row">
            <div className="col-3">Product List</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {data.product_profiles && data.product_profiles.length !== 0 && (
                <>
                  {data.product_profiles.map((item, i) => (
                    <div className="w-100" key={i}>
                      <b>{`${i + 1}. ${item.product_name}`}</b>
                      <div>{ReactHtmlParser(item.product_desc)}</div>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-3">Domain(s) of Activity</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {data.domain_types && data.domain_types.length !== 0 && (
                <>
                  {data.domain_types.map((item, i) => (
                    <div key={i}>{item.domain_name}</div>
                  ))}
                </>
              )}
              {(data?.any_other_flag === 1 ||
                (data?.any_other_domain &&
                  data.any_other_domain !== "null")) && (
                <div>{data?.any_other_domain}</div>
              )}
            </div>
          </div>

          {Array.isArray(data?.area_management) &&
            data.area_management.length > 0 && (
              <>
                <div className="row mt-3">
                  <div className="col-12">
                    <b>Area Management</b>
                  </div>
                </div>
                {data.area_management.map((am, idx) => (
                  <div className="row" key={idx}>
                    <div className="col-12">
                      <div className="row">
                        <div className="col-3">Location</div>
                        <div className="col-1">:</div>
                        <div className="col-7">{am.location}</div>
                      </div>
                      {am.sub_location && (
                        <div className="row">
                          <div className="col-3">Sub Location</div>
                          <div className="col-1">:</div>
                          <div className="col-7">{am.sub_location}</div>
                        </div>
                      )}
                      {am.area_in_sqft && (
                        <div className="row">
                          <div className="col-3">Area (Sqft)</div>
                          <div className="col-1">:</div>
                          <div className="col-7">{am.area_in_sqft}</div>
                        </div>
                      )}
                      {am.built_space_type && (
                        <div className="row">
                          <div className="col-3">Built Space Type</div>
                          <div className="col-1">:</div>
                          <div className="col-7">{am.built_space_type}</div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </>
            )}
          <div className="row">
            <div className="col-3">Capital Investment (Cr.)</div>
            <div className="col-1">:</div>
            <div className="col-7">{data.capital_investment}</div>
          </div>

          {/* Financial Records Section */}
          {data.financial_records && data.financial_records.length > 0 && (
            <>
              <div className="row mt-3">
                <div className="col-12">
                  <b>Financial Records</b>
                </div>
              </div>
              {data.financial_records.map((record, idx) => (
                <div key={idx} className="border-bottom pb-2 mb-2">
                  <div className="row">
                    <div className="col-3">Financial Year {idx + 1}</div>
                    <div className="col-1">:</div>
                    <div className="col-7">{record.financial_year}</div>
                  </div>
                  <div className="row">
                    <div className="col-3">Turnover (Cr.)</div>
                    <div className="col-1">:</div>
                    <div className="col-7">{record.fy_turnover}</div>
                  </div>
                  {record.remarks && (
                    <div className="row">
                      <div className="col-3">Remarks</div>
                      <div className="col-1">:</div>
                      <div className="col-7">{record.remarks}</div>
                    </div>
                  )}
                </div>
              ))}
            </>
          )}
          {data.fe_component && (
            <div className="row">
              <div className="col-3">FE Component</div>
              <div className="col-1">:</div>
              <div className="col-7">{data.fe_component}</div>
            </div>
          )}

          {/* Human Resources */}
          <div className="row mt-3">
            <div className="col-12">
              <b>Human Resources</b>
            </div>
          </div>
          <div className="row">
            <div className="col-3">Direct Employees (Total)</div>
            <div className="col-1">:</div>
            <div className="col-7">{data.ex_man_power}</div>
          </div>
          <div className="row">
            <div className="col-12">
              <b>Direct Employees Split</b>
            </div>
          </div>
          <div className="row">
            <div className="col-3">Male</div>
            <div className="col-1">:</div>
            <div className="col-7">{data.dir_employ_male}</div>
          </div>
          <div className="row">
            <div className="col-3">Female</div>
            <div className="col-1">:</div>
            <div className="col-7">{data.dir_employ_female}</div>
          </div>
          <div className="row">
            <div className="col-3">Genderqueer</div>
            <div className="col-1">:</div>
            <div className="col-7">{data.dir_employ_others}</div>
          </div>
          <div className="row">
            <div className="col-3">SC/ST</div>
            <div className="col-1">:</div>
            <div className="col-7">{data.dir_employ_sc_st}</div>
          </div>

          {/* Other info retained */}
          {data.achievements && data.achievements !== "null" && (
            <div className="row mt-3">
              <div className="col-3">Achievements</div>
              <div className="col-1">:</div>
              <div className="col-7">{data.achievements}</div>
            </div>
          )}
          {data.certification && (
            <div className="row mt-2">
              <div className="col-3">Certifications</div>
              <div className="col-1">:</div>
              <div className="col-7">
                {data?.certification != "Other"
                  ? data.certification
                  : data.otherCertification}
              </div>
            </div>
          )}
          <div className=" row mt-3 ">
            <div className="col-3">Current Application Status</div>
            <div className="col-1">:</div>
            <div className="col-7 blink_me1">
              {activeStatus(data?.project_status)}
            </div>
          </div>
          {data?.admin_message && data?.admin_message !== "" && (
            <div className="row">
              <div className="col-3">Admin Message</div>
              <div className="col-1">:</div>
              <div className="col-7">{data.admin_message}</div>
            </div>
          )}
          {data?.super_admin_message && data?.super_admin_message !== "" && (
            <div className="row">
              <div className="col-3">Super Admin Message</div>
              <div className="col-1">:</div>
              <div className="col-7">{data.super_admin_message}</div>
            </div>
          )}

          {adminType === 1 && (
            <>
              {(data?.project_status === 0 || data?.project_status === 3) && (
                <div className="d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn btn-approve btn-success mr-2"
                    onClick={(e) => saMessage(1)}
                  >
                    Submit for Acceptance
                  </button>
                  <button
                    type="button"
                    className="btn btn-approve btn-warning "
                    onClick={(e) => saMessage(5)}
                  >
                    Revert
                  </button>
                </div>
              )}
            </>
          )}
          {adminType === 2 && (
            <>
              {data?.project_status === 1 && (
                <div className="d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn btn-approve btn-success "
                    onClick={(e) => saMessage(2)}
                  >
                    Approve
                  </button>
                  <button
                    type="button"
                    className="btn btn-approve btn-warning mx-2"
                    onClick={(e) => saMessage(3)}
                  >
                    Revert
                  </button>

                  <button
                    type="button"
                    className="btn btn-reject  btn-danger "
                    onClick={(e) => handleAdminActions(4)}
                  >
                    Reject
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
